interface IProps {
    width?: number;
    height?: number;
}

export const Likedicon = (props: IProps) => {
    const {width, height} = props;
    return (<svg
        xmlns="http://www.w3.org/2000/svg"
        width={width || 12}
        height={height || 13}
        viewBox="0 0 12 13"
        fill="none"
    >
        <path
            d="M1.69101 6.99097L5.99732 11.771L10.3017 6.99303L10.3022 6.99258C10.5514 6.71704 10.7411 6.39304 10.8594 6.04096C10.9778 5.68861 11.0221 5.31563 10.9897 4.94534C10.9573 4.57513 10.8489 4.2155 10.671 3.88902C10.4932 3.56256 10.2498 3.27637 9.95627 3.04836C9.6627 2.82029 9.3252 2.65534 8.965 2.56375C8.60477 2.47216 8.22958 2.4559 7.86275 2.51604C7.49595 2.57617 7.14551 2.71138 6.83336 2.91321C6.52144 3.1149 6.25457 3.37876 6.04931 3.68822L6.04879 3.689L5.99732 3.76601L5.94479 3.68741C5.73885 3.37915 5.47161 3.11657 5.15975 2.9161C4.84785 2.7156 4.49797 2.5815 4.132 2.52215C3.76603 2.4628 3.3917 2.47945 3.03243 2.5711C2.67314 2.66274 2.33662 2.82743 2.04379 3.05483C1.75096 3.28224 1.5081 3.56753 1.33036 3.89292C1.15256 4.2184 1.04389 4.57691 1.01079 4.94609C0.977693 5.3153 1.0209 5.68746 1.13795 6.03935C1.25501 6.39125 1.44336 6.71516 1.69101 6.99097Z"
            fill="#FD81F5"
        />
    </svg>);
}